/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import toastr from '@/lib/notifications';
import $ from 'jquery';
import _ from 'underscore';
import store from '../state/store';

store.on('tutor_proposals:remove', function(params) {
  if (params == null) { params = {}; }
  return $.ajax({
    url: `/api/sales/tutoring_jobs/${params.tutoring_job_id}/tutor_proposals/${params.tutor_proposal_id}`,
    type: 'DELETE',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(params),
    success: (data) => {
      const tutor_proposals = _.select(store.get().tutor_proposals, tutor_proposal => tutor_proposal.id !==params.tutor_proposal_id);

      return store.get().set({tutor_proposals});
    },
    error: (data) => {
      return toastr.error(__guard__(data != null ? data.responseJSON : undefined, x => x.custom_error_message) || 'something went wrong');
    }
  });
});

function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
}